import CouponOwnershipDisplay from './CouponOwnershipDisplay'
export default CouponOwnershipDisplay